import { useTranslation } from 'react-i18next';

const TestimonialSection = () => {
  const { t } = useTranslation();

  const testimonials = [
    {
      name: t('home:testimonials.user1.name'),
      role: t('home:testimonials.user1.role'),
      content: t('home:testimonials.user1.content'),
      rating: 5,
      avatar: 'https://public.readdy.ai/ai/img_res/a9696527c92b0546629b0392706816af.jpg'
    },
    {
      name: t('home:testimonials.user2.name'),
      role: t('home:testimonials.user2.role'),
      content: t('home:testimonials.user2.content'),
      rating: 5,
      avatar: 'https://readdy.ai/api/search-image?query=young%20professional%20woman%20headshot%20portrait%20clean%20background&width=100&height=100&seq=testimonial2&orientation=squarish'
    },
    {
      name: t('home:testimonials.user3.name'),
      role: t('home:testimonials.user3.role'),
      content: t('home:testimonials.user3.content'),
      rating: 5,
      avatar: 'https://readdy.ai/api/search-image?query=business%20executive%20man%20headshot%20portrait%20clean%20background&width=100&height=100&seq=testimonial3&orientation=squarish'
    }
  ];

  return (
    <section className="py-20 px-4 bg-gradient-to-br from-gray-50 to-teal-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('home:testimonials.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('home:testimonials.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed mb-6 text-base">
                "{testimonial.content}"
              </p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img src={testimonial.avatar} alt={testimonial.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="font-bold text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-500">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-6">{t('home:testimonials.trustedBy')}</p>
          <div className="flex flex-wrap items-center justify-center gap-8">
            <div className="flex items-center gap-2 text-gray-700">
              <i className="ri-shield-check-line text-2xl text-green-600"></i>
              <span className="font-semibold">{t('home:testimonials.badges.secure')}</span>
            </div>
            <div className="flex items-center gap-2 text-gray-700">
              <i className="ri-verified-badge-line text-2xl text-teal-600"></i>
              <span className="font-semibold">{t('home:testimonials.badges.verified')}</span>
            </div>
            <div className="flex items-center gap-2 text-gray-700">
              <i className="ri-award-line text-2xl text-orange-500"></i>
              <span className="font-semibold">{t('home:testimonials.badges.award')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
